const POLL_INTERVAL_MS = 100
const TIMEOUT_MS = 10000

const waitForShopify = () => new Promise((resolve, reject) => {
    if (window.shopify) {
        resolve(window.shopify)
        return
    }

    const startedAt = Date.now()
    const timer = setInterval(() => {
        if (window.shopify) {
            clearInterval(timer)
            resolve(window.shopify)
        } else if (Date.now() - startedAt >= TIMEOUT_MS) {
            clearInterval(timer)
            reject(new Error('App Bridge not available'))
        }
    }, POLL_INTERVAL_MS)
})

export const getSessionToken = async () => {
    const shopify = await waitForShopify()
    return shopify.idToken()
}



// WEBPACK FOOTER //
// ./src/helpers/session-token.js